module.exports = __webpack_public_path__ + "static/media/solidity-intermediate.bead071a.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/levels/solidity-intermediate.png
// module id = 1475
// module chunks = 147